<template>
  <div class="craftingModalInfoTooltip" :class="{ 'ru-locale': $i18n.locale === 'ru' }">
    <p v-if="BigNumber(recipeToCraft?.duration || 0).gt(0)" v-html="$t('craftingModalInfoTooltipMessage1')"></p>
    <p v-else v-html="$t('craftingQueueLimitTooltipMessageTextImmediate', { maxQueue: currentRecipe?.maxQueue })" />

    <br />
    <template v-if="recipeToCraft?.duration">
      <p v-html="$t('craftingModalInfoTooltipMessage2')"></p>
      <br />
    </template>

    <p v-if="recipeToCraft?.duration" v-html="$t('craftingModalInfoTooltipMessage3')"></p>
    <p v-else v-html="$t('craftingInfoTooltipImmediate')"></p>
  </div>
</template>

<script lang="ts" setup>
import { BigNumber } from 'bignumber.js';
import type { RecipeProps } from '~/types/crafting';

const { data: recipeToCraft } = useNuxtData<RecipeProps>('recipes/recipe');
const currentRecipe = inject<Ref<RecipeProps>>('currentRecipe');
</script>

<style lang="scss">
.craftingModalInfoTooltip {
  p span {
    color: var(--blue_highlight);
  }
}
</style>
